<script>
  import { onMount } from 'svelte';
  import { sourcesURL } from './settings';
  
  let loading = true;
  let error = false;
  let list = [];

  onMount(async () => {
    try {
      const response = await fetch(sourcesURL);
      const content = await response.json();
      if (content.error) {
        console.warn(content.error);
        loading = false;
        error = true;
      } else {
        list = content.data.map(d => d.source);
        loading = false;
      }
    } catch(e) {
      console.warn(e);
      loading = false;
      error = true;
    }
  })
</script>

<div id="sources" class="{loading ? 'loading' : ''}">
  {#if error}
    <p class="error">C'è stato un problema nel caricamento dei dati, per favore riprova più tardi.</p>
  {:else}
    <div class="sources--content">
      <h3>Metodo e Fonti</h3>
      <p>Ogni notte un nostro <em>bot</em> (un programma in grado di eseguire una serie di istruzioni in maniera autonoma) cerca online articoli che siano stati classificati dai loro autori (tramite <em>Keywords</em>) come relative a <strong>Meloni</strong> o <strong>Schlein</strong>. Una volta salvato il link, un secondo <em>bot</em> ne salva il titolo e la descrizione (tramite i meta-tag <em>title</em>, <em>og:title</em>, <em>description</em>, o <em>og:description</em>).</p>
      <p>I nostri bot rispettano i servizi a cui attingiamo, eseguendo una sola richiesta al giorno per ogni articolo e non salvando nulla che non sia stato specificamente pensato per la condivisione come, appunto, i meta-tag open graph.</p>
      <p>Ad oggi, le nostre fonti includono (in ordine casuale): <span>{#each list as l, index}<em>{l}</em>{#if index < list.length - 1}, {/if}{/each}</span>.</p>
      <p>Ad intervalli regolari un terzo <em>bot</em> si occupa dell'analisi e classificazione degli articoli: il titolo e la descrizione vengono inviati ad un servizio di <em>NLP</em> (Natural Language Processing) che dai testi estrae <em>sentiment</em> (quello che chiamiamo "tono") e <em>keywords</em>. Solo gli articoli per cui siamo in grado di ottenere queste informazioni vengono utilizzati nei grafici mostrati su questa pagina. Gli articoli <em>scartati</em> verranno rianalizzati in seguito: tutti gli algoritmi di Machine Learning, infatti, migliorano col tempo, a mano a mano che <em>imparano</em> nuove cose e che questi insegnamenti vengono confermati da un operatore umano. Questo è il motivo per cui potresti vedere i numeri su questa pagina cambiare senza un evidente motivo.</p>
      <p>Tutte le analisi presentate sono distribuite "così come sono": non ci assumiamo alcuna responsabilità in caso di imprecisioni o imperfezioni; il metodo di raccolta delle informazioni è altamente automatizzato, con solo una minima supervisione umana. <strong>Non attribuire a questo sito validità scientifica</strong>, consideralo solamente un esperimento (più o meno) divertente.</p>
    </div>
  {/if}
</div>
<style>
  #sources {
    align-items: center;
    display: flex;
    height: auto;
    justify-content: center;
    margin: 0 20px;
    opacity: 1;
    padding: 25vh 0 0 0;
    transition: opacity .5s ease-in-out;
    width: auto;
  }

  #sources.loading {
    opacity: 0;
  }

  #sources p {
    text-align: left;
  }

  @media screen and (min-width: 768px) {
    #sources {
      max-width: 960px;
    }
  }

  @media screen and (min-width: 1024px) {
    #sources {
      margin: 0 auto;
    }
  }
</style>